import './App.css';
import Pages from './Pages/Pages';

function App() {
  return (
    <div className="App">
      <div className="App-content">
        <Pages />
      </div>
    </div>
  );
}

export default App;
